<template>
	<div class="flex1" style="height:100%">
		<Title :title="'速度仿真统计'"></Title>
		<div class="flex SOC-type">
			<span
				v-for="(item, i) in velocityType"
				:key="'velocityType' + i"
				:class="{at: i == velocityTypeAt}"
				@click="setVelocityTypeAt(i)">
				{{ item.label }}
			</span>
		</div>
		<myEchart
			class="myEchart"
			v-if="velocityShow"
			:id="'VelocitySimulation'"
			:options="velocityOptions" />
	</div>
</template>

<script>
import Title from '../title.vue'
import myEchart from './../charts/echarts'
import { dataInterface } from '@/api/dataInterfaceApi'
import * as echarts from 'echarts5'
export default {
    components: {
        Title,
        myEchart
    },
    data() {
        return {
			// 速度仿真统计
			velocityOptions: {},
			velocityShow: false,
			velocityTypeAt: 0,
			velocityType: [
				{
					label: '平均度电里程',
					unit: 'km/度',
					value: 'per_vehicle-平均度电里程'
				},
				{
					label: '变化能耗',
					unit: '度/min',
					value: 'per_vehicle-平均度电能耗'
				}
			]
        }
    },
	mounted() {
		// 速度仿真统计
		this.velocitySimulation()
	},
	methods: {
		// 刷新接口需要每个子组件封装一个getData();
		getData(data) {
			console.log('sf123123123123123123123', data)
			this.dataBase = data
			// 速度仿真统计
			this.velocitySimulation(data)
		},
		
		// 速度仿真统计
		setVelocityTypeAt(i) {
			this.velocityTypeAt = i
			this.velocitySimulation()
		},
		velocitySimulation() {
			let data = this.dataBase
			let params = {}
			let query = this.$route.query
			let itemAt = this.velocityType[this.velocityTypeAt]
			params = {
				// 'enCode': itemAt.value,
				// '@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				// '@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
                "enCode":  itemAt.value,
				"@VEHICLE_VIN": localStorage.getItem("newVehicleNum") || 'LDP31B967MG929008'
			}
			this.velocityShow = false
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return;
				let data = res.sort(function(a, b) { return a.speed - b.speed})
				let xAxis = []
				let yAxis = []
				data.map(item => {
					xAxis.push(item.cur_date)
					// yAxis.push(parseFloat(item.avg_per_kwh_mileage || item.energy_consumption))
                    yAxis.push(parseFloat(item.mileage_per_kwh || item.energy_consuption_per_mileage))
				})
				this.velocityOptions = {
					title: {
						text: itemAt.unit
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross'
						}
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						data: xAxis
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
						name: itemAt.label,
						type: 'line',
						// stack: 'Total',
						smooth: true,
						showSymbol: false,
						lineStyle: {
							width: 2,
							color: '#1968FF'
						},
						emphasis: {
							focus: 'series'
						},
						data: yAxis
					}]
				}
				this.velocityShow = true
			})
			.catch((err) => {
				console.log(err)
			});
		},
    }
}
</script>

<style lang="scss" scoped>
@import '../pcsite/part.scss';

.myEchart {
	height: calc(100% - 100px);
}
</style>